import { createAction, props } from '@ngrx/store';
import {
	AlternativeText,
	AlternativeTextListResource,
	AlternativeTextResource,
	CreateAlternativeText,
} from './alternative-text.model';
import { FlaggenrechtChangeEntryResource } from '@schir-int-client/register-change';

const PREFIX = '[Alternative Text] ';

export const loadAlternativeTexteAction = createAction(PREFIX + 'Load Alternative Texte');

export const loadAlternativeTexteSuccessAction = createAction(
	PREFIX + 'Load Alternative Texte Success',
	props<{
		alternativeTexte: AlternativeTextListResource;
	}>()
);

export const createAlternativeTextEntryAction = createAction(
	PREFIX + 'Create Alternative Text Entry',
	props<{
		flaggenrechtResource: FlaggenrechtChangeEntryResource;
		alternativeText: CreateAlternativeText;
	}>()
);

export const createAlternativeTextEntrySuccessAction = createAction(
	PREFIX + 'Create Alternative Text Entry Success',
	props<{
		alternativeTextResource: AlternativeTextResource;
	}>()
);

export const updateAlternativeTextEntryAction = createAction(
	PREFIX + 'Update Alternative Text Entry',
	props<{
		alternativeTextResource: AlternativeTextResource;
		alternativeText: AlternativeText;
	}>()
);

export const updateAlternativeTextEntrySuccessAction = createAction(
	PREFIX + 'Update Alternative Text Entry Success',
	props<{
		alternativeTextResource: AlternativeTextResource;
	}>()
);

export const deleteAlternativeTextEntryAction = createAction(
	PREFIX + 'Delete Alternative Text Entry',
	props<{
		alternativeTextResource: AlternativeTextResource;
	}>()
);

export const deleteAlternativeTextEntrySuccessAction = createAction(
	PREFIX + 'Delete Alternative Text Entry Success',
	props<{
		alternativeTextResource: AlternativeTextResource;
	}>()
);
